/* global $:false */

export const initTypetext = ({ selector }) => {
  const $typetext = $(selector)
  const originalText = $typetext.text()
  let intervalID

  const checkAndClearInterval = () => {
    if (intervalID) {
      clearInterval(intervalID)
    }
  }

  const delay = (callback, timeout = 1000) => {
    setTimeout(callback, timeout)
  }

  const backspace = () => {
    intervalID = setInterval(() => {
      const text = $typetext.text()
      if (text.length > 0) {
        $typetext.text(text.substr(0, text.length - 1))
      } else {
        checkAndClearInterval()
        delay(type)
      }
    }, 50)
  }

  const type = () => {
    intervalID = setInterval(() => {
      const text = $typetext.text()
      if (text.length < originalText.length) {
        $typetext.text(originalText.substr(0, text.length + 1))
      } else {
        checkAndClearInterval()
        delay(backspace)
      }
    }, 300)
  }

  delay(backspace, 2000)
}
